"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = exports.Tabs = exports.StyledTabs = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
exports.StyledTabs = (0, styles_1.styled)(Tabs_1.default)(({ theme }) => ({
    '& .MuiTab-root': {
        fontSize: 14,
        lineHeight: 1.43,
        fontWeight: 610,
        color: theme.palette.text.secondary,
        padding: '14px 16px',
    },
    '& .MuiTab-root.Mui-selected': {
        color: theme.palette.primary.dark,
    },
    '& .MuiTabs-indicator': {
        height: '4px',
        background: 'transparent',
    },
    '& .MuiTabs-indicator span': {
        display: 'block',
        background: theme.palette.primary.dark,
        height: '4px',
        borderRadius: '100px 100px 0 0',
        width: '87%',
        margin: '0 auto',
    },
}));
const Tabs = (props) => {
    return react_1.default.createElement(exports.StyledTabs, { ...props, TabIndicatorProps: { ...props.TabIndicatorProps, children: react_1.default.createElement("span", null) } });
};
exports.Tabs = Tabs;
exports.Tab = Tab_1.default;
